import * as React from 'react';
import { MediaQuery, Modal, Card } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl, useSelector, useFeatureToggles } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../context/CheckoutSettings/context.js';
import '@swc/helpers';
import '../models/cart/cart-state.js';
import '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import '../models/step-shipping/shipping-methods.js';
import { StepNames } from '../models/shared.js';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/utils';
import '@grandvisionhq/api-client';
import { getSelectedShippingMethod } from '../StepShipping/selectors.js';
import '@grandvisionhq/auth';
import '../selectors.js';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../mappers/errors-mapping.js';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-service-store.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-shipping-state.js';
import '../operations/mutations/set-store.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../utils/get-customer-details-payload.js';
import 'history';
import { getShippingMethodInfo } from '../utils/get-shipping-method-info.js';
import '../utils/has-cart-errors.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../operations/fragments/checkout-mutation-result.js';
import '../operations/fragments/cart-mutation-failures.js';
import '../operations/fragments/recreate-ordered-checkout-failure.js';
import '../operations/fragments/recreate-ordered-checkout-result.js';
import '../operations/fragments/paypal-payment.js';
import '../operations/fragments/saved-user-details.js';
import '../operations/queries/get-checkout-state.js';
import '../operations/queries/get-user-details.js';
import { PickupPointsContainer } from '../StepShipping/modules/ShippingMethods/containers/PickupPointsContainer.js';
import '../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import { ShippingMethodsListContainer } from '../StepShipping/modules/ShippingMethods/containers/ShippingMethodsListContainer.js';
import { PickupStoresContainer } from '../StepShipping/modules/ShippingMethods/containers/PickupStoresContainer.js';
import '@grandvisionhq/shipping';
import '../StepShipping/modules/ShippingMethods/state/selectors.js';
import '@grandvisionhq/forms';
import '../state.js';
import '@grandvisionhq/locations';
import '@grandvisionhq/lib-utils-html';
import 'classnames';
import '../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import '@grandvisionhq/iris-ui';
import 'motion/react';
import '../slots/forms/form-context.js';
import '../slots/summaries/summary-context.js';
import '../slots/summaries/types.js';
import '@grandvisionhq/icons';
import { ServiceStore } from '../modules/ServiceStore/layout/ServiceStore.js';
import '../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import { Footer } from '../modules/Footer/Footer.js';
import '@grandvisionhq/bloomreach';
import { EditableAddressesSummary } from './EditableSummaries/EditableAddressesSummary.js';
import { EditableCompanySummary } from './EditableSummaries/EditableCompanySummary.js';
import { EditableContactDetailsSummary } from './EditableSummaries/EditableContactDetailsSummary.js';
import { EditableInvoiceSummary } from './EditableSummaries/EditableInvoiceSummary.js';
import { EditableLoyaltyPointsSummary } from './EditableSummaries/EditableLoyaltyPointsSummary.js';

const StepOverview = ({ isPickupStore , isPickupPoint , labels , onEdit , onNextClick , onPrevClick , selectedStore , shippingMethodsAsides , serviceStore , selectedPickupPoint , shippingMethod , cartComponent , shippingMethodList , onStoreSelect , onPickupPointSelect , handleOnShippingMethodSelected ,  })=>{
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { getLabel  } = useIntl();
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const { allowAlternativeShippingState =false  } = useFeatureToggles();
    const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
    const shippingMethodInfo = getShippingMethodInfo(labels.summary, shippingMethod, shippingMethodsAsides);
    const { features  } = useCheckoutSettings();
    const showEditButton = !allowAlternativeShippingState;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal, {
        title: labels.completed.shipmentDetailsDelivery,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true,
        isOpen: isModalOpen
    }, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step--overview__delivery-methods"
    }, shippingMethodList ? /*#__PURE__*/ React.createElement(ShippingMethodsListContainer, {
        onChange: ()=>setIsModalOpen(false)
        ,
        asides: shippingMethodsAsides,
        shippingMethodList: shippingMethodList,
        selectedShippingMethod: selectedShippingMethod,
        handleOnShippingMethodSelected: handleOnShippingMethodSelected
    }) : null)), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--overview"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--overview card--colapse-borders"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.yourDetails), /*#__PURE__*/ React.createElement(Card, {
        className: "checkout-card__reset-bottom-border-radius"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, onEdit && !allowAlternativeShippingState && /*#__PURE__*/ React.createElement(Card.Actions, null, /*#__PURE__*/ React.createElement(Card.Button, {
        onClick: ()=>setIsModalOpen(true)
        ,
        children: getLabel('common.actions.edit')
    })), /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head",
        className: "checkout-step--overview__caption"
    }, labels.completed.shipmentDetailsDelivery), /*#__PURE__*/ React.createElement(Card.Text, {
        color: "text-secondary",
        variant: "caption"
    }, shippingMethodInfo.label, " ", shippingMethodInfo.aside && shippingMethodInfo.aside, isPickupStore && !selectedStore && /*#__PURE__*/ React.createElement(PickupStoresContainer, {
        warningMessageOnly: true,
        selectedStore: selectedStore,
        onStoreSelect: onStoreSelect,
        showEditButton: showEditButton
    }), isPickupPoint && !selectedPickupPoint && /*#__PURE__*/ React.createElement(PickupPointsContainer, {
        warningMessageOnly: true,
        onPickupPointSelect: onPickupPointSelect,
        selectedPickupPoint: selectedPickupPoint,
        showEditButton: showEditButton
    })))), isPickupStore && selectedStore && /*#__PURE__*/ React.createElement(PickupStoresContainer, {
        hideTitle: true,
        selectedStore: selectedStore,
        onStoreSelect: onStoreSelect,
        showEditButton: showEditButton
    }), isPickupPoint && selectedPickupPoint && /*#__PURE__*/ React.createElement(PickupPointsContainer, {
        hideTitle: true,
        onPickupPointSelect: onPickupPointSelect,
        selectedPickupPoint: selectedPickupPoint
    }), /*#__PURE__*/ React.createElement(EditableAddressesSummary, {
        labels: labels
    }), /*#__PURE__*/ React.createElement(EditableContactDetailsSummary, {
        labels: labels
    }), /*#__PURE__*/ React.createElement(EditableInvoiceSummary, {
        labels: labels
    }), /*#__PURE__*/ React.createElement(EditableCompanySummary, {
        labels: labels
    }), (features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && serviceStore && !isPickupStore && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ServiceStore, {
        className: "checkout-card__reset-border-radius"
    })), /*#__PURE__*/ React.createElement(EditableLoyaltyPointsSummary, null), isMobile && /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step--overview__cart"
    }, cartComponent), /*#__PURE__*/ React.createElement(Footer, {
        stepName: StepNames.Overview,
        onPrevStep: onPrevClick,
        onNextStep: onNextClick
    }))));
};

export { StepOverview };
//# sourceMappingURL=StepOverview.js.map
